import useConfig from "@/features/config/hooks/useConfig.tsx";

const useAuthorizedUrl = (path: string) => {
  const config = useConfig();

  const url = new URL(`${ config.backendHost }${ path }`);
  url.searchParams.append(`host`, location.host);
  url.searchParams.append(`domain_id`, config.domainId.toString());
  url.searchParams.append(`public_key`, config.publicKey);
  url.searchParams.append(`language`, config.language);

  if (config.debug) {
    url.searchParams.append(`XDEBUG_SESSION`, `XDEBUG_ECLIPSE`);
  }

  return url;
}

export default useAuthorizedUrl;
